import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { LOAN_APPLICATION_ACTION_TYPE } from '../actions';

// The company's DESIGNATED completeness checklist id (`Companies.CompletenessChecklistId`).
// When set, exactly that checklist drives the in-editor "Needed" highlighting; when null (the
// default, or if the read was forbidden) the highlighting falls back to the loan's hidden
// completeness checklist(s) — the global master. See DEV-4603.
const initialState = null;

const completenessDesignationIdReducer = (state = initialState, { type, payload }) =>
  produce(state, () => {
    switch (type) {
      case LOAN_APPLICATION_ACTION_TYPE.GET_COMPLETENESS_DESIGNATION:
        return payload ?? initialState;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default completenessDesignationIdReducer;
